module.exports = __webpack_public_path__ + "img/kriyana.bbb41831.png";